import { useSelector } from "react-redux";

const useAllUserData = () => {
  const data =
    useSelector((globalState) => globalState?.userInfoReducer.userData) || {};
  return data;
};

export default useAllUserData;
